import styled from "styled-components/macro"
import { Modal } from "react-bootstrap"

export const StyledModal = styled(Modal)`
  ${({ theme }) => theme.fonts.TTNormsProMedium};
  color: ${({ theme }) => theme.colors.elevation1};
`
